import { Component, OnInit, ChangeDetectorRef  } from '@angular/core';
import { IntegrationQueueService } from '../../services/integration-queue.service';
import {
  IntegrationQueueLookupRequest,
  IntegrationQueueLookupResponseItem
} from '../../models/integration-queue.models';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-integration-queue',
  imports: [FormsModule, CommonModule],
  templateUrl: './integration-queue.component.html',
  styleUrl: './integration-queue.component.css',
})
export class IntegrationQueueComponent implements OnInit {
  constructor(private integrationQueueService: IntegrationQueueService, private cdr: ChangeDetectorRef) {
   
  }

  model: IntegrationQueueLookupRequest = {
    Page: 1,
    PageSize: 20,
    SearchText: '',
    ShowErrorsOnly: false,
    ShowArchivedOnly: false,
    ShowProducts: true,
    ShowStocks: true,
    ShowPrices: true
  };
  
  items: IntegrationQueueLookupResponseItem[] = [];
  total: number = 0;
  totalFiltered: number = 0;
  totalPages: number = 0;
  currentItem: IntegrationQueueLookupResponseItem | null = null;

  ngOnInit(): void {
      this.loadItems();
  }

  loadItems(): void {
    this.integrationQueueService.lookup(this.model).subscribe({
      next: (response) => {
        this.items = response.Items;
        this.total = response.Total;
        this.totalFiltered = response.TotalFiltered;
        this.totalPages = Math.floor((this.totalFiltered + this.model.PageSize - 1) / this.model.PageSize);

        if (this.model.Page > this.totalPages) {
            this.model.Page = 1;
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Lookup failed', error);
        this.cdr.detectChanges();
      }
    });
  }
  nextPage(): void {
    if (this.model.Page < this.totalPages) {
      this.model.Page++;
      this.loadItems();
    }
  }

  previousPage(): void {
    if (this.model.Page > 1) {
      this.model.Page--;
      this.loadItems();
    }
  }

  toggleShowErrorsOnly(): void {
    this.model.ShowErrorsOnly = !this.model.ShowErrorsOnly;
    this.model.Page = 1;
    this.loadItems();
  }

    toggleShowArchivedOnly(): void {
    this.model.ShowArchivedOnly = !this.model.ShowArchivedOnly;
    this.model.Page = 1;
    this.loadItems();
  }

  toggleShowStocks(): void {
    this.model.ShowStocks = !this.model.ShowStocks;
    this.model.Page = 1;
    this.loadItems();
  }

  toggleShowProducts(): void {
    this.model.ShowProducts = !this.model.ShowProducts;
    this.model.Page = 1;
    this.loadItems();
  }

  toggleShowPrices(): void {
    this.model.ShowPrices = !this.model.ShowPrices;
    this.model.Page = 1;
    this.loadItems();
  }

  getPrettyData(data: string): string {
    return JSON.stringify(JSON.parse(data), null, 2);
  }
}
